import { Select } from '@mui/material';
import { MenuItem } from '@mui/material';
import { FormControl } from '@mui/material';
import React from 'react';
import {
  BLACK_COLOR,
  BLUE_COLOR,
  GREEN_COLOR,
  ORANGE_COLOR,
  PURPLE_COLOR,
  RED_COLOR,
} from '../../../../constants/ColorsConst';
import { InputLabel } from '@mui/material';

export const getEstatusRecibosColor = (id) => {
  return id === 3
    ? RED_COLOR
    : id === 7
    ? BLUE_COLOR
    : id === 8
    ? GREEN_COLOR
    : id === 9
    ? ORANGE_COLOR
    : PURPLE_COLOR;
};

const SelectEstatusRecibosComponent = ({
  value,
  onChange,
  isLabel = false,
  isAll = true,
  variant = 'standard',
  fullWidth = false,
  ignoreIds = [],
}) => {
  return (
    <FormControl size="small" fullWidth={fullWidth} variant={variant}>
      {isLabel && (
        <InputLabel id="update-estatus-recibo-label">
          Estatus de recibo
        </InputLabel>
      )}
      <Select
        variant={variant} // "filled" - "standard" - "outlined"
        labelId="update-estatus-recibo-label"
        id="update-estatus-recibo"
        value={value}
        size="small"
        sx={{
          color: getEstatusRecibosColor(value),
        }}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        label="Estatus del recibo"
      >
        {isAll && (
          <MenuItem value={null} sx={{ color: BLACK_COLOR }}>
            TODOS
          </MenuItem>
        )}
        {!ignoreIds.includes(3) && (
          <MenuItem value={3} sx={{ color: RED_COLOR }}>
            PENDIENTE
          </MenuItem>
        )}
        {!ignoreIds.includes(7) && (
          <MenuItem value={7} sx={{ color: BLUE_COLOR }}>
            CANCELADO
          </MenuItem>
        )}
        <MenuItem value={8} sx={{ color: GREEN_COLOR }}>
          VERIFICADO
        </MenuItem>
        <MenuItem value={9} sx={{ color: ORANGE_COLOR }}>
          INVÁLIDO
        </MenuItem>
        <MenuItem value={10} sx={{ color: 'purple' }}>
          INCOMPLETO
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default SelectEstatusRecibosComponent;
